import viewImg from './viewImg.vue';

var Plugin = {
  install: function install(Vue) {
    Vue.component('view-img', viewImg);
  }
};
export { viewImg };
export default Plugin;


//////////////////
// WEBPACK FOOTER
// ./src/component/viewImg/index.js
// module id = 3
// module chunks = 0